module.exports = __webpack_public_path__ + "static/media/PB-Sound-logo.67b1fca6.png";